import { render, staticRenderFns } from "./FXDetailsModal.vue?vue&type=template&id=8c48cc54&scoped=true"
import script from "./FXDetailsModal.vue?vue&type=script&lang=js"
export * from "./FXDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./FXDetailsModal.vue?vue&type=style&index=0&id=8c48cc54&lang=css"
import style1 from "./FXDetailsModal.vue?vue&type=style&index=1&id=8c48cc54&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c48cc54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c48cc54')) {
      api.createRecord('8c48cc54', component.options)
    } else {
      api.reload('8c48cc54', component.options)
    }
    module.hot.accept("./FXDetailsModal.vue?vue&type=template&id=8c48cc54&scoped=true", function () {
      api.rerender('8c48cc54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/data/components/Modal/FXDetailsModal.vue"
export default component.exports